<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>Actualmente hay {{ carriers.length }} Servicios registrados.</h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <dialog-service
      @close="closeDialogService"
      @update="update"
      :id="id"
      :isVisible="editDialogService"
      :carriersLit="carriers"
    />

    <el-row>
      <!-- Table  -->
      <el-col :span="panelWidth" :offset="2">
        <el-card class="box-card">
          <div v-if="isAdmin" slot="header" style="text-align: right;">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleNewCarrier"
              >Agregar Servicio</el-button
            >
          </div>

          <el-table
            :data="carriers"
            style="width: 100%"
            :default-sort="{ prop: 'name', order: 'descending' }"
            stripe
          >
            <el-table-column
              label="Nombre"
              prop="name"
              align="center"
              width="300"
              sortable
            >
              <template slot-scope="props">
                <h4>{{ props.row.name }}</h4>
                <small>{{ props.row.created_at | formatDate }}</small>
              </template>
            </el-table-column>

            <el-table-column
              label="Codigo"
              align="center"
              prop="code"
              width="300"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  {{ props.row.service }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Paquetería"
              align="center"
              prop="carrier"
              width="300"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  {{ props.row.carrier }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="isAdmin"
                  size="mini"
                  icon="el-icon-edit"
                  round
                  @click="handleEditCarrier(scope.$index, scope.row)"
                  >Editar
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <!-- END Table  -->
    </el-row>

    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { CSApi } from "@/libraries/api";
import DialogService from "@/components/DialogService";

export default {
  name: "Services",
  components: {
    DialogService,
  },
  data() {
    return {
      panelWidth: 20,
      carriers: [],

      id: null,
      editDialogService: false,
    };
  },
  methods: {
    async update() {
      try {
        const response = await CSApi().get(
          `/coverage/service?searchBy=&page=1&pageSize=500`
        );
        if (response)
          this.carriers = response.data.data.filter(
            (service) => service.countryCode == "MX"
          );
      } catch (error) {
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },

    handleEditCarrier(index, row) {
      this.id = row.uuid;
      this.editDialogService = true;
    },

    handleNewCarrier() {
      this.id = null;
      this.editDialogService = true;
    },

    closeDialogService() {
      this.id = null;
      this.editDialogService = false;
    },
  },
  async created() {
    await this.update();
  },

  computed: {
    ...mapState(["current_user"]),
    isAdmin() {
      return this.current_user.role == "admin";
    },
    isSupervisor() {
      return ["supervisor", "admin"].includes(this.current_user.role);
    },
  },
};
</script>

<style scoped>
h4 {
  margin: 2px;
}

.size-medium {
  font-size: 15px;
  font-weight: 100;
}
</style>
